import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Stack, Typography } from "@mui/material";
import { PaperTitle } from "Components/Shared/PaperTitle";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.WhereToPay.Tabs;

export const EShopsSection = () => {
  const { t } = useResource();

  return (
    <Stack gap={2} mt={2}>
      <PrimaryPaper>
        <Stack gap={2} alignItems="center" py={4}>
          <ShoppingCartIcon sx={{ fontSize: 48, color: "grey.400" }} />
          <PaperTitle>{t(RESOURCES.EShops)}</PaperTitle>
          <Typography color="text.secondary" textAlign="center">
            {t(Resources.Common.ComingSoon)}
          </Typography>
        </Stack>
      </PrimaryPaper>
    </Stack>
  );
};
